// @ts-check
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { getBranchesAction } from '../redux/actions/branch-actions';

import { makeStyles } from '@material-ui/core/styles';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { LoadingComponent } from '../components/loading-component.js';
import { FloatingActionButtonSize } from '../components/add-component';

import LocationOnIcon from '@material-ui/icons/LocationOn';
import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

function Branch({ branch }) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Paper
      className={classes.paper}
      elevation={0}
      onClick={() => history.push(`/branches/${branch.id}/view`)}
    >
      <LocationOnIcon fontSize="large" />

      <div>
        <b>{branch.name}</b>
      </div>
    </Paper>
  );
}

function BranchesList({ branches }) {
  const renderBranches = branches.map((value, key) => {
    return (
      <Grid key={key} item xs={6} md={4}>
        <Branch branch={value} />
      </Grid>
    );
  });

  return (
    <Grid container spacing={2}>
      {renderBranches}
    </Grid>
  );
}

export default function BranchesPage() {
  const classes = useStyles();

  const { branches, loading } = useSelector((state) => state.branches);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBranchesAction());
  }, [dispatch]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          {loading && <LoadingComponent />}
          {!loading && (
            <>
              <BackNavigationComponent page="Branches" uri="/" />
              <FloatingActionButtonSize />

              <BranchesList branches={branches} />
            </>
          )}
        </Container>
      </React.Fragment>
    </>
  );
}
